@if (isLoaded) {
  <div class="container-fluid" [@fadeInAnimation]>
    <div class="row">
      <div class="col-xl-1"></div>
      <div class="col-xl-10">
        <div class="card mb-3">
          <div class="card-header">
            <fa-icon [icon]="['fas', 'gavel']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>{{ huvudB2.arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2 (samlingsbeslut) {{ huvudB2.arende.galdenar.namn }} {{ huvudB2.datum | localizeddate:'shortDate' }}
          </div>
          <div class="card-body">
            @if (huvudB2.b2Beslut.length >= 10) {
              <a [routerLink]="['/mina-arenden', huvudB2.arende.id]" class="btn-garanti btn-blue mb-3"><fa-icon [icon]="['fas', 'arrow-left']" class="me-2"></fa-icon>Tillbaka till ärendet</a>
            }
            @if (!!huvudB2.kommantarOvrigt) {
              <p class="h5">Kommentar</p>
              <p class="font-monospace">{{ huvudB2.kommantarOvrigt }}</p>
            }
            @if (!!huvudB2.handlaggarensNotering) {
              <p class="h5">Handläggarens notering</p>
              <p class="font-monospace">{{ huvudB2.handlaggarensNotering }}</p>
            }
            @if (!!huvudB2.kommantarOvrigt || !!huvudB2.handlaggarensNotering) {
              <hr />
            }
            <p class="h5">Delbeslut</p>
            <div class="mb-3">
              <div class="input-group">
                <span class="input-group-text">
                    <fa-icon [icon]="['fas', 'filter']" [fixedWidth]="true"></fa-icon>
                  </span>
                <input [(ngModel)]="filterText" type="text" name="filter" class="form-control rounded-end" placeholder="Filtrera..." (ngModelChange)="applyFilter()">
              </div>
            </div>
            @if (huvudB2.b2Beslut.length) {
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col" [class.order-active]="orderName==='fornamn'" (click)="setOrder('fornamn', ['anstallning.arbetstagare.fornamn'])">
                        <div class="d-flex justify-content-between">
                          Förnamn
                          <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up']" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                        </div>
                      </th>
                      <th scope="col" [class.order-active]="orderName==='efternamn'" (click)="setOrder('efternamn', ['anstallning.arbetstagare.efternamn'])">
                        <div class="d-flex justify-content-between">
                          Efternamn
                          <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up']" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                        </div>
                      </th>
                      <th scope="col" [class.order-active]="orderName==='personNr'" (click)="setOrder('personNr', ['anstallning.arbetstagare.personNr12Siffror'])">
                        <div class="d-flex justify-content-between">
                          Personnummer
                          <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up']" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                        </div>
                      </th>
                      <th scope="col" [class.order-active]="orderName==='lg'" (click)="setOrder('lg', ['lgBeloppTotal_cache'])">
                        <div class="d-flex justify-content-between">
                          <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up']" class="me-2" [flip]="reverse||'vertical'"></fa-icon>
                          Lönegaranti
                        </div>
                      </th>
                      <th scope="col" [class.order-active]="orderName==='fordran'" (click)="setOrder('fordran', ['fordranBeloppTotal_cache'])">
                        <div class="d-flex justify-content-between">
                          <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up']" class="me-2" [flip]="reverse||'vertical'"></fa-icon>
                          Fordran
                        </div>
                      </th>
                      <!--<th scope="col" [class.order-active]="getOrder==='harFil'" (click)="setOrder(['harFil'])">
                      <div class="d-flex justify-content-between">
                        Dokument
                        <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up']" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                      </div>
                    </th>-->
                  </tr>
                </thead>
                <tbody>
                  @for (b of huvudB2.b2Beslut | orderBy: order:reverse:'case-insensitive' | filterBy: userFilter; track b) {
                    <tr [routerLink]="['/anstallning', b.anstallning.id]">
                      <td data-name="Förnamn" title="Förnamn"><span [class.redacted]="b.anstallning.isConfidential">{{ b.anstallning.arbetstagare.fornamn }}</span></td>
                      <td data-name="Efternamn" title="Efternamn"><span [class.redacted]="b.anstallning.isConfidential">{{ b.anstallning.arbetstagare.efternamn }}</span></td>
                      <td data-name="Personnumer" title="Personnummer"><span [class.redacted]="b.anstallning.isConfidential">{{ b.anstallning.arbetstagare.personNr12Siffror }}</span></td>
                      <td data-name="Lönegaranti" title="Lönegaranti i kronor" class="text-right-sm-left" [ngClass]='{ "fordran-lg-diff": b.lgBeloppTotal_cache !== b.fordranBeloppTotal_cache && b.fordranBeloppTotal_cache > 0 && b.lgBeloppTotal_cache <= huvudB2.arende.lgMaxBelopp, "lg-over-max": b.lgBeloppTotal_cache > huvudB2.arende.lgMaxBelopp }'>{{ b.lgBeloppTotal_cache | localizednumber }} kr</td>
                      <td data-name="Fordran" title="Fordran i kronor" class="text-right-sm-left" [ngClass]='{ "fordran-lg-diff": b.lgBeloppTotal_cache !== b.fordranBeloppTotal_cache && b.fordranBeloppTotal_cache > 0 }'>{{ b.fordranBeloppTotal_cache | localizednumber }} kr</td>
                      <!--<td data-name="Dokument" *ngIf="b.harFil">
                      <file-link [file]="b.fil"></file-link>
                    </td>
                    <td data-name="Dokument" *ngIf="!b.harFil">
                      &ndash;
                    </td>-->
                  </tr>
                }
              </tbody>
              @if ((huvudB2.b2Beslut | filterBy: userFilter).length > 1) {
                <tfoot>
                  <tr>
                    <th colspan="3" title="Antal delbeslut">{{ (huvudB2.b2Beslut | filterBy: userFilter).length | localizednumber }} delbeslut</th>
                    <th class="text-end" title="Total lönegaranti i kronor">{{ getSum(huvudB2.b2Beslut | filterBy: userFilter, 'lgBeloppTotal_cache') | localizednumber }} kr</th>
                    <th class="text-end" title="Total fordran i kronor">{{ getSum(huvudB2.b2Beslut | filterBy: userFilter, 'fordranBeloppTotal_cache') | localizednumber }} kr</th>
                    <!--<th></th>-->
                  </tr>
                </tfoot>
              }
            </table>
            @if (role==='adv') {
              <div class="container-fluid mb-3">
                <div class="row">
                  <button [disabled]="!!huvudB2.attest" (click)="attestHuvudB2()" class="btn-garanti btn-blue ms-auto"><fa-icon [icon]="['fas', 'marker']" class="me-2"></fa-icon>Attestera denna {{ huvudB2.arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2:a</button>
                  @if (!(huvudB2.b2Beslut | filterBy: userFilter).length) {
                    <p class="text-muted">Inga träffar</p>
                  }
                </div>
              </div>
            }
          </div>
        }
        @if (!huvudB2.b2Beslut.length) {
          <p class="text-muted">Inga delbeslut</p>
        }
        <hr />
        <p class="h5">{{ huvudB2.arende.arendeTyp.typ==='rek' ? 'R' : 'B' }}2:ans bilagor</p>
        @if (huvudB2.filer.length) {
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" style="width:120px">Datum</th>
                  <th scope="col">Beskrivning</th>
                  <th scope="col" style="width:140px">Dokument</th>
                </tr>
              </thead>
              <tbody>
                @for (d of huvudB2.filer | orderBy: ['-datumSparat', 'beskrivning']; track d) {
                  <tr>
                    <td data-name="Datum" title="Datum">{{ d.datumSparat | localizeddate:'shortDate' }}</td>
                    <td data-name="Beskrivning" title="Beskrivning">{{ d.beskrivning }}</td>
                    <td data-name="Dokument" title="Dokument" class="beslut-file"><file-link [file]="d"></file-link></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
        @if (!huvudB2.filer.length) {
          <p class="text-muted">Inga bilagor</p>
        }
        <a [routerLink]="['/mina-arenden', huvudB2.arende.id]" class="btn-garanti btn-blue"><fa-icon [icon]="['fas', 'arrow-left']" class="me-2"></fa-icon>Tillbaka till ärendet</a>
      </div>
    </div>
  </div>
</div>
</div>
}
